var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapSymbolEvacuationArea = function SvgFiremapSymbolEvacuationArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M10.838 9v1.37H7.713v.941h2.834v1.37H7.713v.95h3.21V15h-4.99V9zm5.329 6-.351-.959h-2.423l-.359.959h-1.832l2.56-6h1.831l2.474 6zm-2.277-2.26h1.455l-.719-1.96z",
    clipRule: "evenodd"
  })));
};
export default SvgFiremapSymbolEvacuationArea;